const USER_ROLES = {
  LIMITED: "limited_user",
  STANDARD: "standard_user",
  ADMIN: "administrator",
};

export default USER_ROLES;
